/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=c71b345a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=c71b345a&scoped=true&lang=scss"
import "./detail.vue?vue&type=style&index=1&id=c71b345a&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71b345a"]])

export default __exports__